<template lang="pug">
    DropDown.hzSelectContainer.vm(ref="dropdown", v-if="items", @show="afterShow", @scroll="scroll", :disabled="disabled")
        template.pr(slot="dropHead")
            select.hzFormElement(ref="select", tabindex="-1", :name="name", :required="required", :multiple="multiple", :disabled="disabled")
                template(v-for="(val, key, index) in itemObj")
                    option(v-if="selected.indexOf(getString(val)) !== -1", :value="val", :index="index", selected) {{key}}
            .hzIptResult.vm(ref="ipt", tabindex="0", :style="iptStyle", @mouseover.stop="iptMouseOver", @mouseout.stop="iptMouseOut",
                 @keydown.stop="inputHandler", @keydown.down.prevent="navigateOptions('next')", 
                 @keydown.up.prevent="navigateOptions('prev')", @keydown.enter.prevent="selectHoveredOption", 
                 @keydown.esc.stop.prevent="$refs.dropdown.hide()", :disabled="disabled")
                i.select-close(v-show="isShowClose", tabindex="-1", @click.prevent.stop="handleEmpty" @keydown.stop="_ => false") ×
                .iptResultInner
                    template(v-if="!selected || !selected.length")
                        font(style="color: #ccc") {{placeholder}}
                    template(v-else)
                        template(v-if="multiple")
                            span(v-for="item in selected") {{getSelectedText(item)}}
                                i(tabindex="-1", @click="remove(item)") ×
                        font(v-else) {{getSelectedText(selected[0])}}
        
        template(slot="dropBody")
            .hzSelectDropBody(ref="itemList")
                .filter.hzSelectFilter.p5(v-if="isShowFilter")
                    input.iptFilter.w.sm(tabindex="-1", type="text", placeholder="搜索", v-model="keyword")
                
                ul(ref="hzSelectUl", :style="{height: this.allFilterKeys.length * 30 + 'px'}")
                    template(v-for="(item, index) in visibleKeys")
                        li(:data-value="getString(filterItemObj[item])", :index="index", :data-key="item", @click="clickLi", :class="clsName(item, index)") {{item || filterItemObj[item]}}

</template>

<script>
    import Keyupdown from './util/keyupdown'
    import DropDown from './dropdown';
    export default {
        name: 'hz-select',
        mixins: [Keyupdown],
        components: { DropDown },
        props: {
            iptStyle: null,
            name: { type: String, default: '' },
            required: { type: Boolean, default: false },
            items: null,
            isAll: { type: Boolean, default: false },
            allText: { type: String, default: '全部' },
            value: null, //默认值
            multiple: { type: Boolean, default: false },
            isShowFilter: { type: Boolean, default: false },
            disabled: { type: Boolean, default: false },
            placeholder: { type: String, default: '请选择...'},
            clearable: { type: Boolean, default: false},
            multipleLimit: { type: Number, default: 0 } //多选个数限制，0则为不限制
        },
        
        data() {
            return {
                _timer: null,
                keyword: '',
                currentValue: null,
                scrollTop: 0,
                mouseoverFlag:false
            }
        },

        computed: {
            allCurrentText() {
                return this.allText || 'Please select';
            },

            filterItemObj() {
                if(!this.keyword) {
                    return this.itemObj;
                }
                let keyword = this.keyword.toUpperCase();
                let ret = {};
                for(var key in this.itemObj) {
                    if(key && key.toUpperCase().indexOf(keyword) !== -1) {
                        ret[key] = this.itemObj[key];
                    }
                }

                return ret;
            },

            allFilterKeys() {
                //将allText放在第一位
                let keys = Object.keys(this.filterItemObj);
                if(this.isAll && !this.multiple) {
                    let allText = this.allCurrentText;
                    let index = keys.indexOf(allText);
                    if(index > -1) {
                        keys.splice(index, 1);
                        keys.splice(0, 0, allText);
                    }
                }
                return keys;
            },

            visibledStartIndex() {
                let startIndex = parseInt(this.scrollTop / 30);
                startIndex = startIndex - 200;
                startIndex < 0 && (startIndex = 0);

                return startIndex;
            },

            //以下参数为设置滚动条效率用的，数据太多时，滚动效率差
            visibleKeys() {
                return this.allFilterKeys.slice(this.visibledStartIndex, this.visibledStartIndex + 400);
            },

            allFilterValues() {
                return Object.values(this.filterItemObj).map(one => this.getString(one));
            },

            itemsLength() {
                return this.allFilterValues.length;
            },

            itemObj() {
                let obj = {};
                this.isAll && !this.multiple && (obj[this.allCurrentText] = '');
                
                if(this.items instanceof Array) {
                    this.items.map(one => {
                        if(one) {
                            obj[one] = one;
                        }
                    })
                }
                else {
                    obj = Object.assign(obj, this.items);
                    let objBak = {};
                    for(let key in obj){
                        objBak[key.toString()] = obj[key];
                    }
                    obj = objBak;
                }

                return obj;
            },

            allValues() {
                return Object.values(this.itemObj).map(one => this.getString(one ));
            },

            selected() {
                if(this.currentValue === null || this.currentValue === undefined) {
                    return [];
                }
                let selected = (this.currentValue instanceof Array)? this.currentValue : [this.currentValue];
                selected = selected.map(one => this.getString(one));
                return selected.filter(one => this.allValues.indexOf(one) !== -1);
            },
            isShowClose(){
                if(this.clearable && this.mouseoverFlag){
                    if(this.multiple){
                        if(this.currentValue.length > 0){
                            return true;
                        }
                    }else if(this.currentValue){
                        return true;
                    }
                }

                return false;
            }
        },

        watch: {
            items:{
                handler: function(old, newVal) {
                    if(JSON.stringify(old) != JSON.stringify(newVal)) {
                        this.init();
                    }
                },
                deep: true
            },

            value(val) {
                this.init();
            }
        },

        mounted() {
            this.init();
            var slc = this.$refs.select;
            //调用hz.tools.form.fill赋值时，值会在data('value')上
            if(slc) {
                slc.onchange = e => {
                    let val = $(slc).data('value');
                    val && val.split && (val = val.split(',').filter(one => !!one));
                    if(val === '' || val === null || val === undefined) {
                        this.setDefault();
                    }
                    else {
                        this.currentValue = this.multiple? val : val[0];
                        this._fireInputEvent();
                    }
                }
            }
        },

        methods: {
            clsName(item, index){
                const activeFlag = this.selected.indexOf(this.getString(this.filterItemObj[item])) !== -1;
                if(this.multiple && this.multipleLimit > 0 && !activeFlag){
                    if(this.multipleLimit <= this.selected.length){
                        return {disabled: true}
                    }
                }
                return {active: activeFlag, hover: index === this.hoverIndex}
                
            },


            getString(val) {
                if(val === null || val === undefined) {
                    return '';
                }
                return val.toString();
            },

            iptMouseOver(){
                this.mouseoverFlag = true;
            },

            iptMouseOut(){
                this.mouseoverFlag = false;
            },

            handleEmpty(){
                if(this.multiple){
                    this.currentValue = [];
                }else{
                    this.currentValue = '';
                }
                this.$refs.ipt.blur();
                this.change();
            },

            init() {
                if(this.value === '' || this.value === null || this.value === undefined) {
                    this.setDefault();
                }
                else {
                    if(this.multiple) {
                        this.currentValue = this.value instanceof Array? this.value: [this.value];
                        this.currentValue = this.currentValue.map(one => this.getString(one));
                    }
                    else {
                        this.currentValue = this.getString(this.value);
                    }
                    $(this.$refs.select).data('value', this.currentValue);
                }
            },

            afterShow() {
                this.keyword = '';
                this.hoverIndex = -1;
            },
            
            scroll(height, scrollTop, dropBody) {
                this.scrollTop = scrollTop;
                this.$nextTick(e => {
                    $(this.$refs.hzSelectUl).css('padding-top', this.visibledStartIndex * 30 + 'px');
                })
            },

            setDefault() {

                if(this.multiple) {
                    this.currentValue = []
                }else{
                    this.currentValue = ''
                }
                // if(this.isAll) {
                //     this.currentValue = '';
                //     return;
                // }
                
                // for(var key in this.itemObj) {
                //     if(this.itemObj.hasOwnProperty(key)) {
                //         this.currentValue = this.getString(this.itemObj[key]);
                //         this._fireInputEvent();
                //         return;
                //     }
                // }
                
            },
            
            //处理全选
            inputHandler() {
                if(!this.multiple) {
                    return false;
                }
                if(event.keyCode == 65 && (event.ctrlKey || event.metaKey)) {
                    event.preventDefault();
                    if(this.getString(this.currentValue) === this.getString(this.allFilterValues)) {
                        this.currentValue = null;
                    }
                    else {
                        this.currentValue = this.allFilterValues.slice(0);
                    }

                    this.change();
                    return false;
                }
            },

            setSelected(val) {
                if(this.multiple) {
                    if(val instanceof Array) {
                        this.currentValue = val;
                    }
                    else if(val) {
                        this.currentValue = [val];
                    }
                    else {
                        this.currentValue = null;
                    }
                }
                else {
                    this.currentValue = val;
                }
            },

            clickLi(e) {
                let li = e.currentTarget;
                let value = li.getAttribute('data-value');

                if(this.multiple) {
                    console.log(li.classList.contains("disabled"))

                    if(li.classList.contains("disabled")) return ;

                    let index = (this.currentValue || []).indexOf(value);
                    if(index > -1) {
                        if(this.multiple || this.currentValue.length instanceof Array) {
                            this.currentValue.splice(index, 1);
                            this.change();
                            return;
                        }
                    }
                    this.currentValue? this.currentValue.push(value) : (this.currentValue = [value]);
                }
                else {
                    this.currentValue = value;
                    this.$refs.dropdown && this.$refs.dropdown.hide();
                }
                // console.log('click li:', this.currentValue, value);
                this.change();
            },
            
            //多选时才能remvoe
            remove(item) {
                let index = this.currentValue? this.currentValue.indexOf(item) : -1;
                this.currentValue.splice(index, 1);
                this.change();
            },

            _fireInputEvent() {
                this.$nextTick(e => {
                    $(this.$refs.select).data('value', this.currentValue).val(this.currentValue);
                })
                
                this.$emit('input', this.currentValue);
            },

            change() {
                this._fireInputEvent();
                // $(this.$refs.select).data('value', this.currentValue);
                this.$emit('change', this.currentValue);
                // this.$emit('input', this.currentValue);
            },

            getSelectedText(val) {
                for(var key in this.itemObj) {
                    let itemVal = this.itemObj[key];
                    let eq = typeof itemVal === 'number'? itemVal === parseInt(val) : this.getString(itemVal) === this.getString(val);
                    if(eq) {
                        return key;
                    }
                }
                return val;
            },

            filter(e) {
                e.preventDefault();
                this._timer && clearTimeout(this._timer);
                this._timer = setTimeout( t => {
                    this.keyword = e.target.value.trim().toUpperCase();
                }, 300)
            },
            
            val() {
                return this.currentValue;
            }
        }
    }
</script>

<style lang="stylus" scoped>
    .hzIptResult
        position relative
        i.select-close
            position absolute
            right 5px
            top 7px
            background #c0c4cc
            border-radius 8px
            width 16px
            height 16px
            text-align center
            color #fff
            cursor pointer 
            font-size 14px
            display flex
            justify-content center
            align-items center
            padding-right 1px
            outline none
    select 
        display block
        position absolute
        left 0
        right 0
        top 0
        bottom 0
        z-index -1
        opacity 0
        
    .iptInner
        width 100%
        overflow hidden
    .hzSelectContainer
        display inline-block
        position relative
        width 170px
        &:focus
            outline none
            
    .hzSelectDropBody
        display flex
        flex-direction column
        height 100%
        min-width 120px
        .filter
            flex 0 0 28px            
        ul
            overflow hidden
            li
                white-space nowrap
                line-height 30px
                height: 30px
                padding 0 25px 0 10px
                cursor pointer
                font-size 12px
                position relative
                font-weight 500
                &:hover
                    background-color #f5f7fa
                &:after
                    content "へ"
                    display block
                    position absolute
                    right 5px
                    top 0
                    font-size 12px 
                    font-weight 600
                    transform scale(0.8) rotateX(-180deg) 
                    display none
                &.active
                    color #3993ef
                    &:after
                        display block
                &.disabled
                    color #C0C4CC
                    cursor not-allowed
                    &.hover
                        background-color #fff
                &.hover 
                    background-color #3993ef
                    color #fff
</style>
            



// WEBPACK FOOTER //
// src/select.vue